// Admin API client — /admin/audit-logs/* (mirrors the API's audit-logs aggregate).

import type { AdminAuditLog } from '@a7y/types';
import { client, PaginatedResponse } from './transport';

export const auditLogsApi = {
  // Audit Logs
  getAuditLogs: (params?: { page?: number; limit?: number; userId?: string; action?: string }) =>
    client.get<PaginatedResponse<AdminAuditLog>>(
      `/audit-logs?${new URLSearchParams(params as Record<string, string>)}`
    ),
};
